<template>
  <div>
    <!-- header end -->
    <!-- main content start -->
    <section class="main-content">
      <!-- form sectionstart -->
      <div class="form-section">
        <form>
          <!-- form field -->
          <div class="field">

            <div class="filed-block">
              <!-- add "has-value" class for label animation when
              input has some value and on field focus-->
              <input @blur="$v.name.$touch()" required type="text" v-model="$v.name.$model" :class="{'input': true, 'has-value': this.name
              }" />
              <label class="label">Full Name</label>
            </div>
            <!-- error message -->
          <span v-if="$v.name.$dirty">
            <p v-if="!$v.name.required" :class="{'error': true}">Full name is required</p>

            <p v-if="!$v.name.minLength" :class="{'error': true }">
              Please enter your full name.</p>
          </span>
          </div>

          <div class="field">
            <div class="filed-block">
              <!-- Use has-error class id error -->
              <input
              required
              @blur="$v.email.$touch()"
                v-model="$v.email.$model"
                id="error"
                type="text"
                :class="{'input': true, 'has-value': this.email}"
              />
              <label class="label">Email</label>
            </div>
            <!-- error message -->
            <div v-if="$v.email.$dirty" >
              <p :class="{'error': true, 'is-hidden': $v.email.email}">Please enter your email.</p>
              <p :class="{'error': true, 'is-hidden': $v.email.required}">Email is required</p>
            </div>
          </div>
          <div class="field">
            <div class="filed-block">
              <input
              @blur="$v.phone.$touch()"
              required
                type="number"
                v-model="$v.phone.$model"
                :class="{'input': true, 'has-value': this.phone}"
              />
              <label class="label">Phone Number</label>
            </div>
            <span v-if="$v.phone.$dirty">
              <p
              v-if="!$v.phone.minLength"
              :class="{'error': !$v.phone.minLength}"
            >Please enter your phone number</p>

              <p
              v-if="!$v.phone.maxLength"
              :class="{'error': true}"
            >Please enter your phone number</p>
            <p v-if="!$v.phone.required" :class="{'error': $v.phone.minLength}">
              Phone number is required
            </p>
            </span>
          </div>
          <div class="field">
            <div class="filed-block">
              <input
              @blur="$v.dob.$touch()"
              id="datepicker"
                type="date"
                name
                v-model="$v.dob.$model"
                placeholder
                class="input has-value"
                max="2001-11-21"
              />
              <label for="datepicker" class="label">Date of Birth</label>
            </div>
            <span v-if="$v.dob.$dirty">
              <p class="error is-hidden">Please enter your date of birth</p>
              <p v-if="!$v.dob.required" class="error">Date of birth required</p>
            </span>
          </div>
          <div class="note">Take a picture of your next Monster Hydro to enter the draw:</div>
          <p class="error">{{unique}}</p>
          <!-- file upload control  -->
          <div class="field">
            <div class="upload-btn-wrapper">
              <!-- <button class="btn-file">Upload a file</button> -->
              <div class="upload-block">
                <!-- control icon -->
                <div class="file-icon">
                  <img src="../assets/upload-icon.svg" alt="img" />
                </div>
                <div class="file-info">
                  <div class="file-label">Upload Picture</div>
                  <!-- add different file status class with below "file-status" class -->
                  <!-- is-uploading, is-completed, is-failed  -->
                  <div>
                    <!-- uploding icon -->
                    <!-- <div class="icon icon-uploading" v-if="fileUpload.isUploading">
                      <img src="../assets/spinner.svg" class="spinner" alt="image" />
                    </div> -->
                    <!-- coompleted icon -->
                    <span class="icon icon-completed" v-if="fileUpload.uploadSuccess === true">
                      <img src="../assets/completed.svg" alt="image" />
                    </span>
                    <!-- failed icon  -->
                    <span class="icon icon-failed" v-if="fileUpload.uploadSuccess === false">
                      <img src="../assets/failed.svg" alt="image" />
                    </span>
                    <p class="file-name" v-if="fileUpload.file !== ''">{{fileUpload.file.name}}</p>
                    <p class="error" v-if="fileUpload.error !== ''">Upload Failed</p>
                  </div>
                </div>
              </div>
              <input @change="fileSelected" type="file" name="myfile" />
              <div v-if="imageFail">
                <p class="error">{{imageFail}}</p>
              </div>
            </div>
          </div>
          <!-- submit button -->
          <div class="submit-button">
            <input
             v-if="!fileUpload.isUploading"
            required
              type="submit"
              @click.prevent="signup"
              name
              placeholder
              class="input btn-submit"
              value="Sign Up"
            >
              <span class="icon icon-uploading" v-else>
                <img src="../assets/spinner.svg" class="spinner" alt="image" />
              </span>

          </div>
        </form>
      </div>
      <!-- form section end -->
      <p class="copyright-section">
        By signing up for this draw, you agree to Monster's
        <a
          href="http://monsterenergycontests.com/"
        >contest rules, terms and conditions</a>.
      </p>
    </section>
    <!-- main content end -->
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */

import axios from 'axios'
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators'
import {
  URL, apiToken, IMAGE_URL, imageApiToken
} from '@/env'

export default {
  data () {
    return {
      name: '',
      email: '',
      dob: '',
      phone: '',
      signedUp: false,
      unique: '',
      imageFail: '',

      fileUpload: {
        file: '',
        isUploading: false,
        uploadSuccess: '',
        error: '',
        fullURL: '',
        uploadURL: ''
      }
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(7),
      maxLength: maxLength(20)
    },
    phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    email: {
      required,
      email
    },
    dob: {
      required
    }
  },
  methods: {
    async signup () {
      // console.log(this.$v);
      this.unique = ''
      if (!this.$v.$invalid) {
        console.log(this.$v.$invalid)
        if (this.fileUpload.file) {
          this.fileUpload.isUploading = true

          const headers = {
            'api-token': apiToken
          }
          const url = `${URL}/api/v1/users`
          let response1
          try {
            response1 = await this.createResource()
          } catch (error) {
            this.fileUpload.isUploading = true

            // console.log(error.response.data.msg);
            // if (error.response.data.msg === 'there was a problem processing your request.') {
            //   this.imageFail = 'Please Upload an image';
            // }
          }
          const { payload } = response1.data
          this.fileUpload.fullURL = payload.full_url
          this.fileUpload.uploadURL = payload.upload_url

          const uploadHeaders = {
            'Content-Type': this.fileUpload.file.type
          }
          let uploadedResource
          try {
            uploadedResource = await this.uploadResource(
              payload.upload_url,
              this.fileUpload.file,
              uploadHeaders
            ).then((res) => {
              console.log(res)
            })
          } catch (error) {
            console.log(error.response)
          }

          let name = this.$v.name.$model.replace(/\s\s+/g, ' ')
          name = name.replace(/[';"!@#$%^&*]/g, '')
          name = name.split(' ')

          const firstName = name[0]
          const lastNameIndex = name.length - 1
          const lastName = name[lastNameIndex]

          const data = {
            first_name: firstName,
            last_name: lastName,
            email: this.$v.email.$model,
            phone: this.$v.phone.$model,
            dob: this.$v.dob.$model,
            image_url: this.fileUpload.fullURL,
            marketing: true
          }
          await axios.post(url, data, { headers })
            .then((res) => {
              this.$root.signedUp = true
              console.log(res)
              this.fileUpload.isUploading = true
              this.unique = res.data.msg
              this.fileUpload.isUploading = false
              if (res.data.msg === 'user has already been registered') {
                this.$root.registered = true
                this.$root.msg = res.data.msg
              }
            })
        } else {
          this.imageFail = 'Please upload an image'
        }
      }
      this.$v.name.$touch()
      this.$v.email.$touch()
      this.$v.phone.$touch()
      this.$v.dob.$touch()
      if (!this.fileUpload.file) {
        console.log(this.selectedFile)
        this.imageFail = 'Please upload an image'
      }
    },
    fileSelected (file) {
      this.imageFail = ''
      const selectedFile = file.target.files[0]

      this.fileUpload.uploadSuccess = true

      if (file.target.files.length < 1) {
        return
      }
      this.fileUpload.file = selectedFile
    },
    createResource () {
      const file = this.fileUpload.file
      const uploadData = {
        name: file.name,
        content_type: file.type,
        folder: 0
      }
      const headers = {
        'api-token': imageApiToken
      }
      return axios.post(`${IMAGE_URL}/api/v1/resources/upload`, uploadData, {
        headers
      })
    },
    uploadResource (url, file, headers) {
      return axios.put(url, file, { headers })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
